<template>
    <div class="form_grp f-col@lg:12" :class="{'is:danger': isError}">
        <label class="form_label">{{label}}</label>
        <div class="form_ctrl">
            <input :type="type" class="input" v-bind="$attrs" v-bind:value="value" v-on="inputListeners">
            <div class="form_note" v-if="isError">{{message}}</div>
            <div class="form_note" v-if="!isError && hasTip">{{tip}}</div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        name: 'form-input',
        inheritAttrs: false,
        props: {

            label: String,
            error: [String, Array],
            value: [String, Number],
            tip: String,
        },
        data() {
            const vm = this
            return {
                type: 'text',
                message: '',
            }
        },
        mounted() {
            const vm = this
            vm.type = vm.$attrs.hasOwnProperty('type') ? vm.$attrs.type : vm.type

        },
        watch: {
            error(val) {
                if (val && val !== '') {
                    this.message = Array.isArray(val) ? val[0] : val
                } else {
                    this.message = ''
                }

            }
        },
        computed: {
            inputListeners() {
                const vm = this
                // `Object.assign` 将所有的对象合并为一个新对象
                return Object.assign({},
                    // 我们从父级添加所有的监听器
                    this.$listeners,
                    // 然后我们添加自定义监听器，
                    // 或覆写一些监听器的行为
                    {
                        // 这里确保组件配合 `v-model` 的工作
                        input: function (event) {
                            vm.message = ''
                            vm.$emit('input', event.target.value)
                        }
                    }
                )
            },
            isError() {
                return !!this.message
            },
            hasTip(){
                return !!this.tip
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .form_grp {
        margin-bottom: 12px;
    }
</style>
